import { render } from "./GridIcon.vue?vue&type=template&id=275f6bee&scoped=true"
import script from "./GridIcon.vue?vue&type=script&lang=js"
export * from "./GridIcon.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildagent/work/4109ecccb628e132/monorepo_migration/wijmo-sample/reference-samples/config/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-275f6bee"]])

export default __exports__